module.exports = __webpack_public_path__ + "static/img/home.76dc98d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home.png
// module id = yvNz
// module chunks = 6